module.exports = __webpack_public_path__ + "media/images/recruit/section/img-section-bea8b6026e39d89cfc2305b17242a21c.svg";